import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import DashboardCard, { ChartBody, ChartEmpty, ChartPlot, ChartTooltip } from './DashboardCard';

interface LostReasonsChartProps {
    data: { name: string; value: number; color: string }[];
}

const LostReasonsChart: React.FC<LostReasonsChartProps> = ({ data }) => {
    return (
        <DashboardCard title="Motivo de perda">
            {data.length === 0 ? (
                <ChartEmpty>Sem perdas neste período.</ChartEmpty>
            ) : (
                <ChartBody>
                    <ChartPlot>
                            <PieChart>
                                <Pie
                                    data={data}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    innerRadius="62%"
                                    outerRadius="88%"
                                    paddingAngle={4}
                                    stroke="none"
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                <Tooltip content={<ChartTooltip />} />
                            </PieChart>
                    </ChartPlot>
                    <ul className="flex max-h-16 flex-wrap justify-center gap-x-s3 gap-y-s1 overflow-y-auto pt-s3 scrollbar-premium">
                        {data.map((item) => (
                            <li key={item.name} className="flex items-center gap-s1 text-sm text-muted">
                                <span
                                    className="size-2 shrink-0 rounded-full"
                                    style={{ backgroundColor: item.color }}
                                />
                                <span className="max-w-[140px] truncate" title={item.name}>
                                    {item.name}{' '}
                                    <span className="font-mono font-medium">({item.value})</span>
                                </span>
                            </li>
                        ))}
                    </ul>
                </ChartBody>
            )}
        </DashboardCard>
    );
};

export default LostReasonsChart;
